import { cn } from "@/lib/utils";
import {
  Star,
  UtensilsCrossed,
  Tag,
  Receipt,
  Home,
} from "lucide-react";

export type TabletSection = "highlights" | "menu" | "offers" | "rating" | "bill";

interface TabletSidebarProps {
  activeSection: TabletSection;
  onSectionChange: (section: TabletSection) => void;
  hasOpenBill: boolean;
}

const sections: { id: TabletSection; label: string; icon: React.ElementType }[] = [
  { id: "highlights", label: "Início", icon: Home },
  { id: "menu", label: "Cardápio", icon: UtensilsCrossed },
  { id: "offers", label: "Ofertas", icon: Tag },
  { id: "rating", label: "Avalie", icon: Star },
  { id: "bill", label: "Conta", icon: Receipt },
];

export function TabletSidebar({
  activeSection,
  onSectionChange,
  hasOpenBill,
}: TabletSidebarProps) {
  return (
    <aside className="fixed left-0 top-[68px] bottom-0 w-24 bg-slate-900 border-r border-slate-800 flex flex-col justify-between py-4 z-40">
      {/* Menu items */}
      <div className="flex flex-col">
        {sections.map((section) => {
          const Icon = section.icon;
          const isActive = activeSection === section.id;

          return (
            <button
              key={section.id}
              onClick={() => onSectionChange(section.id)}
              className={cn(
                "flex flex-col items-center justify-center py-5 px-2 transition-all duration-200 relative",
                isActive
                  ? "bg-primary/10 text-primary"
                  : "text-slate-400 hover:text-white hover:bg-slate-800/50"
              )}
            >
              {/* Active indicator */}
              {isActive && (
                <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-8 bg-primary rounded-r-full" />
              )}

              <Icon className="w-7 h-7 mb-1.5" />
              <span className="text-xs font-medium">{section.label}</span>

              {/* Bill indicator */}
              {section.id === "bill" && hasOpenBill && (
                <div className="absolute top-3 right-3 w-2 h-2 bg-primary rounded-full" />
              )}
            </button>
          );
        })}
      </div>

      {/* Footer - Powered by ActualFood */}
      <div className="px-2 py-4 text-center border-t border-slate-800">
        <p className="text-[10px] text-slate-500 leading-tight">
          Powered by
        </p>
        <p className="text-xs font-semibold text-cyan-400">
          Altus Food
        </p>
      </div>
    </aside>
  );
}
